import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

class SkilletGridCLession {
  constructor() {
    this.customSelect();
    this.resizeEvents();
    this.categoryFilter();
    this.lessonSearch();
    this.lessonLoadMore();
    if ($(window).width() < 1025) {
      this.lessonGrid();
    }
  }

  customSelect() {
    if ($('.custom-select').length > 1) {
      var x, i, j, l, ll, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName('custom-select');
      l = x.length;
      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName('select')[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement('DIV');
        a.setAttribute('class', 'select-selected');
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement('DIV');
        b.setAttribute('class', 'select-items select-items--is-hide');
        for (j = 1; j < ll; j++) {
          /*for each option in the original select element,
                    create a new DIV that will act as an option item:*/
          c = document.createElement('DIV');
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.setAttribute(
            'data-catid',
            selElmnt.options[j].getAttribute('value'),
          );
          c.setAttribute(
            'data-taxonomy',
            selElmnt.options[j].getAttribute('data-taxonomy'),
          );
          c.addEventListener('click', function (e) {
            /*when an item is clicked, update the original select box,
                        and the selected item:*/
            var y, i, k, s, h, sl, yl, currentText;
            s = this.parentNode.parentNode.getElementsByTagName('select')[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                currentText = this.innerHTML;
                currentText =
                  'Clear Filter' == currentText ? 'Filter' : currentText;
                h.innerHTML = currentText;
                y = this.parentNode.getElementsByClassName('same-as-selected');
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute('class');
                }
                this.setAttribute('class', 'same-as-selected');
                break;
              }
            }
            h.click();
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener('click', function (e) {
          /*when the select box is clicked, close any other select boxes,
                    and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle('select-items--is-hide');
          this.classList.toggle('select-selected--is-active');
        });
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
                except the current select box:*/
        var x,
          y,
          i,
          xl,
          yl,
          arrNo = [];
        x = document.getElementsByClassName('select-items');
        y = document.getElementsByClassName('select-selected');
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i);
          } else {
            y[i].classList.remove('select-selected--is-active');
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add('select-items--is-hide');
          }
        }
      }
      /*if the user clicks anywhere outside the select box,then close all select boxes:*/
      document.addEventListener('click', closeAllSelect);
    }
  }

  lessonGrid() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    var Swipes = new Swiper('.lesson-grid-slider', {
      slidesPerView: 2,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      speed: 500,
      // loop:true,
      allowTouchMove: true,
      pagination: {
        el: '.lesson-grid-slider .slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.lesson-grid-slider .slider__button-next',
        prevEl: '.lesson-grid-slider .slider__button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });
  }

  resizeEvents() {
    $(window).on('resize', () => {
      this.lessonGrid();
    });
  }

  categoryFilter() {
    $(document).on(
      'click',
      '.gradeFilter .select-items div, .themeFilter .select-items div',
      (e) => {
        e.preventDefault();
        var elem = $(e.currentTarget),
          datacatid = elem.attr('data-catid'),
          datataxonomy = elem.attr('data-taxonomy'),
          searchKey = $('#searchInputLesson').val();

        $('#skilletGridLesson').attr('data-' + datataxonomy + '-id', datacatid);
        this.ajaxFunctions(datataxonomy, searchKey);
      },
    );
  }

  lessonSearch() {
    $(document).on('click', '.lessonSearch', (e) => {
      e.preventDefault();
      var elem = $(e.currentTarget),
        searchKey = $('#searchInputLesson').val();

      this.ajaxFunctions('', searchKey);
    });
  }

  ajaxFunctions(datataxonomy, searchKey) {
    var catGradeId = $('#skilletGridLesson').attr('data-grade-id'),
      catThemeId = $('#skilletGridLesson').attr('data-foodcorps-theme-id'),
      select9PostId = $('#skilletGridLesson').attr('data-select9PostId'),
      select5PostId = $('#skilletGridLesson').attr('data-select5PostId');

    $('.team-grid__content').css('opacity', 0.4);
    var data = {
      searchKey: searchKey,
      taxonomy: datataxonomy,
      catGradeId: catGradeId,
      catThemeId: catThemeId,
      select9PostId: select9PostId,
      select5PostId: select5PostId,
      action: 'lessonFilter',
    };
    $.ajax({
      url: foodcorps_object.ajaxurl,
      data: data,
      type: 'POST',
      success: function (response) {
        if (response.post9Lists.length > 0) {
          $('.post9ListsGrid').show();
          $('.post9ListsGrid .row').html(response.post9Lists);
          var total = $('.post9ListsGridcol-section').length;
          if (total > 3) {
            $('#lesson-load-more').removeClass('d-none');
          }
        } else {
          $('.post9ListsGrid').hide();
        }

        if (response.postLists.length > 0) {
          $('.postListsBulletListOne').show();
          $('.postListsBulletListOne ul.bullet-list').html(response.postLists);
        } else {
          $('.postListsBulletListOne').hide();
        }

        if (response.post5Lists.length > 0) {
          $('.post5ListsGrid').show();
          $('.post5ListsGrid .swiper-wrapper').html(response.post5Lists);
          if ($(window).width() < 1025) {
            this.lessonGrid();
          }
        } else {
          $('.post5ListsGrid').hide();
        }

        if (response.postListsAll.length > 0) {
          $('.postListsAllBullet').show();
          $('.postListsAllBullet ul.bullet-list').html(response.postListsAll);
        } else {
          $('.postListsAllBullet').hide();
        }

        $('.skillet-no-post-found').hide();
        if (
          response.post9Lists.length == 0 &&
          response.postLists.length == 0 &&
          response.post5Lists.length == 0 &&
          response.postListsAll.length == 0
        ) {
          $('.skillet-no-post-found').show();
        }
        $('.team-grid__content').css('opacity', 1);
      },
    });
  }

  lessonLoadMore() {
    $(document).on('click', '#lesson-load-more', (e) => {
      e.preventDefault();
      var elem = $(e.currentTarget);
      var total = $('.post9ListsGridcol-section').length;
      var numberOfResultsVisible = parseInt(
        $('div.post9ListsGridcol-section:visible').length,
      );
      var maxcount = numberOfResultsVisible + 3;

      for (let index = numberOfResultsVisible; index <= maxcount; index++) {
        $('.post9ListsGridcol-section:nth-child(' + index + ')').addClass(
          'd-block',
        );
        $('.post9ListsGridcol-section:nth-child(' + index + ')').removeClass(
          'd-none',
        );
        if (total <= index) {
          elem.addClass('d-none');
        }
      }
    });
  }
}

export default SkilletGridCLession;
new SkilletGridCLession();
